import {TreatmentTarget} from '../treatments/treatment_target'

export class PbxAudioTreatment extends TreatmentTarget { 
  constructor(domain_id) {
    super();
    this.domain_id = domain_id;
  }
  
  setTarget(target) {
    this.target = target
  }

  validate() {
    let response = {}
    this.querySelectorAll('select').forEach((input) => { 
      input.classList.remove("error")
      if(input.value === "null") {
        input.classList.add("error")
        response.requiredMissing = true 
      }
    });
    return response;
  }

  getData() {
    let audio_id = this.querySelector("select").value;
    let target = { 
      target_name: `Play Audio ${audio_id}`,
      target_type: "IVR", 
      ring_to_number: null,
      ivr_target_audio_id: audio_id,
      ivr_choice_timeout: 0,
      children: [],
      actions: []
    };
  return target;
  }

  getIcon() {
    return 'fa-headphones'
  }

  static getType() {
    return "AUDIO"
  }

  connectedCallback() {
    this.innerHTML = `
      <div class="col-sm-12 ct_action" data-action_type=AUDIO>
      <div class="panel panel-default" style="min-height: 100px;">
        <h4 style="margin: 10px 10px;">Play Audio</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
        <div class="form-group">
          <label>Choose Audio to Play</label>
          <div class="row">
            <div class="col-md-9 no-gutters">
              <select is=audio-select class="form-control audio_id" data-selected=${this.target != null ? this.target.ivr_target_audio_id : 'null'} 
              data-selected-name="${this.target != null && this.target.target_audio != null ? this.target.target_audio.audio_desc : 'null'}" data-selected-domain="${this.domain_id}" target_audio_type=2></select>
              <div class="manage_audio">
              <a class="btn btn-primary ct_manage_audio" data-audio-type-id="2" style="width:100%;">Manage</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 ct_line">
      <div class="ct_vertical_arrow"></div>
      <div class="option_text">Audio finished playing</div>
      <div class="ct_vertical_arrow">
        <div class=arrow-down></div>
      </div>
    </div>
    `;
    super.connectedCallback();
  }
}
customElements.define('pbx-audio-treatment', PbxAudioTreatment);